import '../util/string';
import { Button, Grid } from '@material-ui/core';
import React, { Component, Fragment } from 'react';
import { Animated } from 'react-animated-css';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import join from 'url-join';
import axios from '../axios-default';
import ConfirmDialog from '../components/Dialog/ConfirmDialog';
import WarningDialog from '../components/Dialog/WarningDialog';
import Loader from '../components/Loader';
import NewPatientPhoto from '../components/NewPatient/Photos/NewPatientPhoto';
import Photos from '../components/NewPatient/Photos/NewPatientPhotos';
import PrescriptionNotes from '../components/NewPatient/PrescriptionNotes/NewPatientPrescriptionNotes';
import { ApiServerUrl } from '../config.json';
import * as actionTypes from '../store/NewPatient/actionType';
import * as saveAction from '../store/NewPatient/NewPatient.action';
import NewPatientHandleUpload from '../util/NewPatientHandleUpload';
import { easySnackbar } from '../store/Noti/noti.actions';
import NewConfirmDialog from '../components/Dialog/NewConfirmDialog';
import { withLang } from '../util/lang';
import { getFormToken } from '../util/file';
import PercentageProgressRing from '../components/PercentageProgressRing';
import { getWebAbsPath } from '../util/path';
import style2 from '../components/NewPatient/Photos/NewPatientPhoto.module.css';
import AlertDialog from '../components/Dialog/Dialog';
import Banner from '../components/Banner';
import { FORM_TYPE } from '../components/NewPatient/PrescriptionNotes/type';
import { fetchConnectPlatformData } from '../store/ConnectPlatform/connectPlatform';
import { checkFormFields, isConditionsHavingErrors } from '../util/alignerPrescriptionFormHelper';
import { ROLE_NAMES } from '../util/const';
import LoadingSpinner from '../components/Loader/LoadingSpinner';

class Refinement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rayFiles: [],
            LoadingStatus: false,
            loading: false,
            uploading: false,
            comments: '',
            caseId: this.props.match.params.id,
            patientId: this.props.match.params.patientsid,
            role: JSON.parse(localStorage.getItem('role')),
            mandatoryPhotoWithoutData: false,
            mandatoryPhotoDataValidation: false,
            mandatoryPhotoValidationDarft: false,
            refinementData: null,
            initialRefinementInfo: null,
            error: '',
            draftConfirmation: false,
            submitConfirmation: false,
            refinement_id: null,
            case_detail_id: null,
            case_file_id: null,
            case_impression_id: null,
            defectCurrentStatus: {
                currentDefectFlow: {
                    dr_response: null,
                    defect_type: null,
                    haveRequireNextSet: null,
                },
            },
            threeshapeConnected: false,
            ray_draft_changed: false,
            dbxPopup: false,
            dbxFileCount: 0,
            currentPatientValidation: false,
            currentPatientValidationMessage: 'Please enter valid number for current patient step.',
            isUnderRetrackFlow: false,
            retrackFileResult: '',
            retrackImpressionResult: '',
            retrackStepNumberResult: '',
        };
        this.progressBarRef = React.createRef(null);
    }

    handleEnableChoose3dFileChange(value) {
        this.props.handleEnableChoose3dFile(value);
    }

    handleChoose3dFile(value) {
        this.props.handleChoose3dFile(value);
    }

    fetchCbctFileCount = async (folderName) => {
        try {
            const file_list = await axios.get(`dropbox/getFileCount/${folderName}/0`);
            if (file_list.data.file_count > 0) {
                this.setState({ dbxFileCount: file_list.data.file_count });
            }
        } catch (e) {
            console.error('Error fetching file count', e);
        }
    };

    async componentDidMount() {
        this.setState({ LoadingStatus: true });

        // Purpose: get retrack case data
        // Explain: if not RETRACK_END, then return empty string object
        const retrackData = await axios.get(`/retrack/caseRetrackData/${this.state.caseId}`);
        const retrackDataResult = retrackData.data.result;
        if (retrackDataResult.retrackFileResult !== '' && retrackDataResult.retrackImpressionResult !== '') {
            this.setState({ isUnderRetrackFlow: true });
            this.setState({
                retrackFileResult: retrackDataResult.retrackFileResult,
                retrackImpressionResult: retrackDataResult.retrackImpressionResult,
            });
        }

        // get case info
        const caseInfo = await await axios.get(`case/${this.state.caseId}`);
        let patientId = caseInfo.data.case[0].patient_id;
        this.setState({ patientId: patientId });

        const defectCurrentStatus = await (await axios.get(`case/defect/flow/${this.state.caseId}`)).data;
        this.setState({ defectCurrentStatus: defectCurrentStatus });
        let { data } = await axios.get(`case/refinement/${this.state.caseId}`);
        //decide weather it is refinement or defect by path name
        const path_name = window.location.pathname;
        let draftFileListUrl = 'mobile_app/doctor/draft_file_list';
        let draftFileList = {};
        let chosenDraftFile = 0;
        if (path_name.includes('defect_resubmit')) {
            // false is defect resubmit , not refinement
            this.setState({ defect_resubmit_flag: true });
        }

        let {
            data: { rayFiles },
        } = await axios.get('/case/getRayFiles/' + this.state.caseId);
        if (rayFiles) {
            this.setState({ rayFiles: rayFiles });
        }

        let refinementDraft = data.case_refinement.filter((v, index) => {
            return v.refinement_status === 'DRAFT';
        });
        if (data.case_refinement.length > 0) {
            if (refinementDraft.length > 0) {
                let refinement_id = refinementDraft[0]['refinement_id'];
                let enable_ray_select_choose3d_file = refinementDraft[0]['enable_ray_select_choose3d_file'];
                let case_rfs_id = refinementDraft[0]['case_rfs_id'];
                let case_detail_id = refinementDraft[0]['case_detail']['case_detail_id'];
                let case_impression_id = refinementDraft[0]['case_file']['case_file_id'];
                let case_file_id = refinementDraft[0]['case_impression']['case_impression_id'];
                draftFileListUrl += `?case_id=${this.state.caseId}&refinement_id=${refinement_id}`;
                chosenDraftFile = refinementDraft[0]['chosen_draft_file'];

                if (data && this.state.patientInfo == null) {
                    let intialState = {};
                    intialState['enableRaySelectChoose3dFile'] = enable_ray_select_choose3d_file;
                    intialState['caseRfsId'] = case_rfs_id;
                    intialState['isRayCase'] = case_rfs_id && case_rfs_id > 0 ? 1 : 0;

                    if (
                        refinementDraft[0].refinement_status === 'DRAFT' &&
                        refinementDraft[0].case_detail.new_prescription_notes_flag === false
                    ) {
                        // use default value of prescription notes if the refinement draft is using old questionnaire
                        refinementDraft[0].case_detail.attr0 = 'both';
                        refinementDraft[0].case_detail.attr1 = 'placeAttachmentsAsNeeded';
                        refinementDraft[0].case_detail.attr2 = 'delayToStage';
                        refinementDraft[0].case_detail.attr3 = 'coverageExtending';
                        refinementDraft[0].case_detail.attr4 = 'maintain';
                        refinementDraft[0].case_detail.attr5 = 'maintain';
                        refinementDraft[0].case_detail.attr6 = 'closeAllSpaces';
                        refinementDraft[0].case_detail.attr7 = 'asNeeded';
                        refinementDraft[0].case_detail.attr8 = 'asNeeded';
                        refinementDraft[0].case_detail.attr9 = 'asNeeded';
                        refinementDraft[0].case_detail.attr10 = 'asNeeded';
                        refinementDraft[0].case_detail.attr11 = 'asNeeded';
                        refinementDraft[0].case_detail.attr12 = 'asNeeded';
                    }

                    let retrackStepNumber = retrackDataResult.retrackStepNumberResult;
                    this.setState({ retrackStepNumberResult: retrackStepNumber });

                    //set patient prescription notes record
                    intialState['archToTreat'] = refinementDraft[0].case_detail.attr0
                        ? refinementDraft[0].case_detail.attr0
                        : this.setDefaultValueStepPosition(retrackStepNumber);
                    // "both";

                    intialState['archToTreatUpperStep'] = refinementDraft[0].case_detail
                        .refinement_arch_to_treat_upper_step
                        ? refinementDraft[0].case_detail.refinement_arch_to_treat_upper_step
                        : retrackStepNumber.aligner_upper;
                    intialState['archToTreatLowerStep'] = refinementDraft[0].case_detail
                        .refinement_arch_to_treat_lower_step
                        ? refinementDraft[0].case_detail.refinement_arch_to_treat_lower_step
                        : retrackStepNumber.aligner_lower;

                    let newExcludedDentitionArray = [];
                    if (refinementDraft[0].case_detail.new_excluded_dentition !== '') {
                        newExcludedDentitionArray = refinementDraft[0].case_detail.new_excluded_dentition.split(',');
                        for (let a in newExcludedDentitionArray) {
                            newExcludedDentitionArray[a] = parseInt(newExcludedDentitionArray[a], 10);
                        }
                    }
                    intialState['notToTreat1'] = newExcludedDentitionArray;

                    var doNotPlaceArray = [],
                        placeArray = [];
                    if (refinementDraft[0].case_detail.new_excluded_attachments !== '') {
                        var doNotPlaceArray = refinementDraft[0].case_detail.new_excluded_attachments.split(',');
                        for (var a in doNotPlaceArray) {
                            doNotPlaceArray[a] = parseInt(doNotPlaceArray[a], 10);
                        }
                    }

                    if (refinementDraft[0].case_detail.new_included_attachments !== '') {
                        var placeArray = refinementDraft[0].case_detail.new_included_attachments.split(',');
                        for (var a in placeArray) {
                            placeArray[a] = parseInt(placeArray[a], 10);
                        }
                    }

                    intialState['attachments1'] = {
                        value: refinementDraft[0].case_detail.attr1
                            ? refinementDraft[0].case_detail.attr1
                            : 'placeAttachmentsAsNeeded',
                        doNotPlace: doNotPlaceArray,
                        place: placeArray,
                        delay: {
                            value: refinementDraft[0].case_detail.attr2
                                ? refinementDraft[0].case_detail.attr2
                                : 'delayToStage',
                            stage: refinementDraft[0].case_detail.attr63 ? refinementDraft[0].case_detail.attr63 : '',
                        },
                    };
                    intialState['anteriorPosteriorRelationship1'] = {
                        r: refinementDraft[0].case_detail.attr4 ? refinementDraft[0].case_detail.attr4 : 'maintain',
                        l: refinementDraft[0].case_detail.attr5 ? refinementDraft[0].case_detail.attr5 : 'maintain',
                    };
                    intialState['spacingAndCrowding1'] = {
                        spacing: {
                            value: refinementDraft[0].case_detail.attr6
                                ? refinementDraft[0].case_detail.attr6
                                : 'closeAllSpaces',
                            location: refinementDraft[0].case_detail.attr64
                                ? refinementDraft[0].case_detail.attr64
                                : '',
                        },
                        crowding: {
                            resolveUpper: {
                                expand: {
                                    value: refinementDraft[0].case_detail.attr7
                                        ? refinementDraft[0].case_detail.attr7
                                        : 'asNeeded',
                                    teeth: refinementDraft[0].case_detail.attr48
                                        ? refinementDraft[0].case_detail.attr48
                                        : '',
                                },
                                procline: {
                                    value: refinementDraft[0].case_detail.attr8
                                        ? refinementDraft[0].case_detail.attr8
                                        : 'asNeeded',
                                    teeth: refinementDraft[0].case_detail.attr49
                                        ? refinementDraft[0].case_detail.attr49
                                        : '',
                                },
                                IPRAnterior: {
                                    value: refinementDraft[0].case_detail.attr9
                                        ? refinementDraft[0].case_detail.attr9
                                        : 'asNeeded',
                                    teeth: refinementDraft[0].case_detail.attr50
                                        ? refinementDraft[0].case_detail.attr50
                                        : '',
                                },
                                IPRPosteriorRight: {
                                    value: refinementDraft[0].case_detail.attr10
                                        ? refinementDraft[0].case_detail.attr10
                                        : 'asNeeded',
                                    teeth: refinementDraft[0].case_detail.attr51
                                        ? refinementDraft[0].case_detail.attr51
                                        : '',
                                },
                                IPRPosteriorLeft: {
                                    value: refinementDraft[0].case_detail.attr11
                                        ? refinementDraft[0].case_detail.attr11
                                        : 'asNeeded',
                                    teeth: refinementDraft[0].case_detail.attr52
                                        ? refinementDraft[0].case_detail.attr52
                                        : '',
                                },
                                extraction: {
                                    value: refinementDraft[0].case_detail.attr12
                                        ? refinementDraft[0].case_detail.attr12
                                        : 'asNeeded',
                                    teeth: refinementDraft[0].case_detail.attr53
                                        ? refinementDraft[0].case_detail.attr53
                                        : '',
                                },
                            },
                            resolveLower: {
                                expand: {
                                    value: refinementDraft[0].case_detail.attr13
                                        ? refinementDraft[0].case_detail.attr13
                                        : 'asNeeded',
                                    teeth: refinementDraft[0].case_detail.attr54
                                        ? refinementDraft[0].case_detail.attr54
                                        : '',
                                },
                                procline: {
                                    value: refinementDraft[0].case_detail.attr14
                                        ? refinementDraft[0].case_detail.attr14
                                        : 'asNeeded',
                                    teeth: refinementDraft[0].case_detail.attr55
                                        ? refinementDraft[0].case_detail.attr55
                                        : '',
                                },
                                IPRAnterior: {
                                    value: refinementDraft[0].case_detail.attr15
                                        ? refinementDraft[0].case_detail.attr15
                                        : 'asNeeded',
                                    teeth: refinementDraft[0].case_detail.attr56
                                        ? refinementDraft[0].case_detail.attr56
                                        : '',
                                },
                                IPRPosteriorRight: {
                                    value: refinementDraft[0].case_detail.attr16
                                        ? refinementDraft[0].case_detail.attr16
                                        : 'asNeeded',
                                    teeth: refinementDraft[0].case_detail.attr57
                                        ? refinementDraft[0].case_detail.attr57
                                        : '',
                                },
                                IPRPosteriorLeft: {
                                    value: refinementDraft[0].case_detail.attr17
                                        ? refinementDraft[0].case_detail.attr17
                                        : 'asNeeded',
                                    teeth: refinementDraft[0].case_detail.attr58
                                        ? refinementDraft[0].case_detail.attr58
                                        : '',
                                },
                                extraction: {
                                    value: refinementDraft[0].case_detail.attr18
                                        ? refinementDraft[0].case_detail.attr18
                                        : 'asNeeded',
                                    teeth: refinementDraft[0].case_detail.attr59
                                        ? refinementDraft[0].case_detail.attr59
                                        : '',
                                },
                            },
                        },
                    };
                    intialState['overJet1'] = {
                        value: refinementDraft[0].case_detail.attr19
                            ? refinementDraft[0].case_detail.attr19
                            : 'maintainInitialOverjet',
                        subValue: refinementDraft[0].case_detail.attr20 ? refinementDraft[0].case_detail.attr20 : '',
                    };
                    intialState['alignersMarginPlacement1'] = refinementDraft[0].case_detail.attr3
                        ? refinementDraft[0].case_detail.attr3
                        : 'coverageExtending';
                    intialState['posteriorCrossbite1'] = {
                        value: refinementDraft[0].case_detail.attr36
                            ? refinementDraft[0].case_detail.attr36
                            : 'maintainInitialCrossbite',
                        subValue: {
                            value: refinementDraft[0].case_detail.attr37
                                ? refinementDraft[0].case_detail.attr37
                                : 'noPreferenceShowResultsInSimulator',
                            subValue: {
                                value: refinementDraft[0].case_detail.attr38
                                    ? refinementDraft[0].case_detail.attr38
                                    : null,
                                buttonPressedDirectlyOnAligner: {
                                    maxillaryTeeth:
                                        refinementDraft[0].case_detail.attr39 &&
                                        refinementDraft[0].case_detail.attr39.includes('maxillaryTeeth')
                                            ? true
                                            : false,
                                    mandibularTeeth:
                                        refinementDraft[0].case_detail.attr39 &&
                                        refinementDraft[0].case_detail.attr39.includes('mandibularTeeth')
                                            ? true
                                            : false,
                                },
                                cutoutToBondButtonDirectlyOnTeeth: {
                                    maxillaryTeeth:
                                        refinementDraft[0].case_detail.attr40 &&
                                        refinementDraft[0].case_detail.attr40.includes('maxillaryTeeth')
                                            ? true
                                            : false,
                                    mandibularTeeth:
                                        refinementDraft[0].case_detail.attr40 &&
                                        refinementDraft[0].case_detail.attr40.includes('mandibularTeeth')
                                            ? true
                                            : false,
                                },
                                otherMethod: refinementDraft[0].case_detail.attr46 || '',
                            },
                        },
                    };
                    let upperDentition = null,
                        lowerDentition = null;
                    if (refinementDraft[0].case_detail.attr43) {
                        if (refinementDraft[0].case_detail.attr43.includes('upperFabricate')) {
                            upperDentition = 'upperFabricate';
                        } else if (refinementDraft[0].case_detail.attr43.includes('upperCutout')) {
                            upperDentition = 'upperCutout';
                        } else if (refinementDraft[0].case_detail.attr43.includes('upperSlipCut')) {
                            upperDentition = 'upperSlipCut';
                        }
                        if (refinementDraft[0].case_detail.attr43.includes('lowerFabricate')) {
                            lowerDentition = 'lowerFabricate';
                        } else if (refinementDraft[0].case_detail.attr43.includes('lowerCutout')) {
                            lowerDentition = 'lowerCutout';
                        } else if (refinementDraft[0].case_detail.attr43.includes('lowerSlipCut')) {
                            lowerDentition = 'lowerSlipCut';
                        }
                    }
                    intialState['auxiliaries1'] = {
                        classIIElastics: refinementDraft[0].case_detail.attr41
                            ? refinementDraft[0].case_detail.attr41
                            : 'No',
                        classIIIElastics: refinementDraft[0].case_detail.attr42
                            ? refinementDraft[0].case_detail.attr42
                            : 'No',
                        subValue: {
                            upper: {
                                value: upperDentition,
                            },
                            lower: {
                                value: lowerDentition,
                            },
                        },
                        otherElastics: {
                            value: refinementDraft[0].case_detail.attr44 ? refinementDraft[0].case_detail.attr44 : 'No',
                            comment: refinementDraft[0].case_detail.attr62 ? refinementDraft[0].case_detail.attr62 : '',
                        },
                    };
                    intialState['openbite1'] = {
                        value: refinementDraft[0].case_detail.attr21
                            ? refinementDraft[0].case_detail.attr21
                            : 'maintainInitialOpenbite',
                        subValue: {
                            value: refinementDraft[0].case_detail.attr22 ? refinementDraft[0].case_detail.attr22 : null,
                            extrudeAnteriorTeeth: {
                                value:
                                    refinementDraft[0].case_detail.attr23 &&
                                    refinementDraft[0].case_detail.attr23.includes('extrudeAnteriorTeeth')
                                        ? true
                                        : false,
                                upper:
                                    refinementDraft[0].case_detail.attr24 &&
                                    refinementDraft[0].case_detail.attr24.includes('upper')
                                        ? true
                                        : false,
                                lower:
                                    refinementDraft[0].case_detail.attr24 &&
                                    refinementDraft[0].case_detail.attr24.includes('lower')
                                        ? true
                                        : false,
                            },
                            intrudePosteriorTeeth: {
                                value:
                                    refinementDraft[0].case_detail.attr23 &&
                                    refinementDraft[0].case_detail.attr23.includes('intrudePosteriorTeeth')
                                        ? true
                                        : false,
                                upper:
                                    refinementDraft[0].case_detail.attr25 &&
                                    refinementDraft[0].case_detail.attr25.includes('upper')
                                        ? true
                                        : false,
                                lower:
                                    refinementDraft[0].case_detail.attr25 &&
                                    refinementDraft[0].case_detail.attr25.includes('lower')
                                        ? true
                                        : false,
                            },
                            placeMiniImplantsTAD: {
                                value:
                                    refinementDraft[0].case_detail.attr23 &&
                                    refinementDraft[0].case_detail.attr23.includes('placeMiniImplantsTAD')
                                        ? true
                                        : false,
                                input: refinementDraft[0].case_detail.attr60
                                    ? refinementDraft[0].case_detail.attr60
                                    : '',
                            },
                        },
                    };
                    intialState['deepBite1'] = {
                        value: refinementDraft[0].case_detail.attr26
                            ? refinementDraft[0].case_detail.attr26
                            : 'maintainExistingDeepBite',
                        subValue: {
                            value: refinementDraft[0].case_detail.attr27 ? refinementDraft[0].case_detail.attr27 : null,
                            intrudeAnteriorTeeth: {
                                value:
                                    refinementDraft[0].case_detail.attr28 &&
                                    refinementDraft[0].case_detail.attr28.includes('intrudeAnteriorTeeth')
                                        ? true
                                        : false,
                                upper:
                                    refinementDraft[0].case_detail.attr29 &&
                                    refinementDraft[0].case_detail.attr29.includes('upper')
                                        ? true
                                        : false,
                                lower:
                                    refinementDraft[0].case_detail.attr29 &&
                                    refinementDraft[0].case_detail.attr29.includes('lower')
                                        ? true
                                        : false,
                            },
                            extrudePosteriorTeeth: {
                                value:
                                    refinementDraft[0].case_detail.attr28 &&
                                    refinementDraft[0].case_detail.attr28.includes('extrudePosteriorTeeth')
                                        ? true
                                        : false,
                                upper:
                                    refinementDraft[0].case_detail.attr30 &&
                                    refinementDraft[0].case_detail.attr30.includes('upper')
                                        ? true
                                        : false,
                                lower:
                                    refinementDraft[0].case_detail.attr30 &&
                                    refinementDraft[0].case_detail.attr30.includes('lower')
                                        ? true
                                        : false,
                            },
                            placeMiniImplantsTAD: {
                                value:
                                    refinementDraft[0].case_detail.attr28 &&
                                    refinementDraft[0].case_detail.attr28.includes('placeMiniImplantsTAD')
                                        ? true
                                        : false,
                                input: refinementDraft[0].case_detail.attr61
                                    ? refinementDraft[0].case_detail.attr61
                                    : '',
                            },
                        },
                    };
                    intialState['midline1'] = {
                        value: refinementDraft[0].case_detail.attr31
                            ? refinementDraft[0].case_detail.attr31
                            : 'maintainInitialMidline',
                        subValue: {
                            value: refinementDraft[0].case_detail.attr32 ? refinementDraft[0].case_detail.attr32 : '',
                            upper: {
                                checked:
                                    refinementDraft[0].case_detail.attr33 &&
                                    refinementDraft[0].case_detail.attr33.includes('upper')
                                        ? true
                                        : false,
                                value: refinementDraft[0].case_detail.attr34
                                    ? refinementDraft[0].case_detail.attr34
                                    : '',
                            },
                            lower: {
                                checked:
                                    refinementDraft[0].case_detail.attr33 &&
                                    refinementDraft[0].case_detail.attr33.includes('lower')
                                        ? true
                                        : false,
                                value: refinementDraft[0].case_detail.attr35
                                    ? refinementDraft[0].case_detail.attr35
                                    : '',
                            },
                        },
                    };

                    const trioDimForceStrValue = refinementDraft[0].case_detail?.trio_dim_force
                        ? refinementDraft[0].case_detail.trio_dim_force
                        : this.props.NewPatientData.trioDimForce;

                    intialState['trioDimForce'] = trioDimForceStrValue;
                    intialState['specialInstructions1'] = refinementDraft[0].case_detail.attr47 ?? '';

                    //set Photo Data
                    let modifiedFilesData = [...this.props.NewPatientData.files];
                    let radioKey = 0,
                        stlKey = 0,
                        key = '';
                    let retrackCaseFile = retrackDataResult.retrackFileResult;
                    let retrackCaseImpression = retrackDataResult.retrackImpressionResult;
                    let refinementCaseFile = refinementDraft[0].case_file;
                    let refinementCaseImpression = refinementDraft[0].case_impression;

                    modifiedFilesData.forEach((v, index) => {
                        if (v.category === 'photo' || v.category === 'radio') {
                            key = v.category === 'radio' ? v.category + radioKey : v.category + index;
                            radioKey = v.category === 'radio' ? radioKey + 1 : 0;
                            let filePath = refinementCaseFile[key]
                                ? refinementCaseFile[key]
                                : this.handleUploadLater(v, refinementCaseFile, retrackCaseFile, key) &&
                                  this.handleWillNotUpload(v, refinementCaseFile, retrackCaseFile, key) &&
                                  retrackCaseFile[key];
                            v['data'] = filePath
                                ? /^https?:\/\//.test(filePath) || /^dbx::/.test(filePath)
                                    ? filePath
                                    : join(ApiServerUrl, filePath)
                                : '';
                            v['dataURL'] = filePath ? v['data'] : null;
                            v['uploaded'] = v['data'] ? true : false;
                            if (v.id === 'cbct') return;
                            v['upload_later'] = this.handleUploadLater(v, refinementCaseFile, retrackCaseFile, key);
                            v['will_not_upload'] = this.handleWillNotUpload(
                                v,
                                refinementCaseFile,
                                retrackCaseFile,
                                key
                            );
                        } else {
                            key = v.category + stlKey;
                            stlKey = stlKey + 1;
                            let filePath = refinementCaseImpression[key]
                                ? refinementCaseImpression[key]
                                : retrackCaseImpression[key];
                            v['data'] = filePath
                                ? /^https?:\/\//.test(filePath)
                                    ? filePath
                                    : join(ApiServerUrl, filePath)
                                : '';
                            v['dataURL'] = filePath ? v['data'] : null;
                            v['uploaded'] = v['data'] ? true : false;
                            v['upload_later'] = this.handleUploadLater(v, refinementCaseFile, retrackCaseFile, key);
                            v['will_not_upload'] = this.handleImpressionWillNotUpload(
                                v,
                                refinementCaseImpression,
                                retrackCaseFile,
                                key
                            );
                        }
                    });

                    intialState['files'] = modifiedFilesData;
                    let refinementImpression = refinementDraft[0].case_impression;
                    // Explain: initialState will be set in setDefaultValueImpressionTextField
                    this.setDefaultValueImpressionTextField(
                        refinementImpression,
                        retrackCaseImpression,
                        retrackCaseFile,
                        intialState
                    );
                    var comments = refinementDraft[0].comment ? refinementDraft[0].comment : '';

                    intialState['ray_draft_changed'] = refinementDraft[0].case_file.ray_draft_changed
                        ? JSON.parse(refinementDraft[0].case_file.ray_draft_changed)
                        : [];
                    this.props.setTempData(intialState);
                }
                this.setState({ refinement_id, case_detail_id, case_impression_id, case_file_id, comments });
            }
        }

        if (data.case_refinement.length === 0 || refinementDraft.length === 0) {
            let intialState = {};
            let retrackCaseFile = retrackDataResult.retrackFileResult;
            let retrackCaseImpression = retrackDataResult.retrackImpressionResult;
            let retrackStepNumber = retrackDataResult.retrackStepNumberResult;
            this.setState({ retrackStepNumberResult: retrackStepNumber });

            intialState['archToTreat'] = this.setDefaultValueStepPosition(retrackStepNumber);
            this.setDefaultValueStepNumber(retrackStepNumber, intialState);

            //set Photo Data
            let modifiedFilesData = [...this.props.NewPatientData.files];
            let radioKey = 0,
                stlKey = 0,
                key = '';
            modifiedFilesData.forEach((v, index) => {
                if (v.category === 'photo' || v.category === 'radio') {
                    key = v.category === 'radio' ? v.category + radioKey : v.category + index;
                    radioKey = v.category === 'radio' ? radioKey + 1 : 0;

                    let filePath = retrackDataResult.retrackFileResult[key];
                    v['data'] = filePath
                        ? /^https?:\/\//.test(filePath) || /^dbx::/.test(filePath)
                            ? filePath
                            : join(ApiServerUrl, filePath)
                        : '';
                    v['dataURL'] = filePath ? v['data'] : null;
                    v['uploaded'] = v['data'] ? true : false;
                    if (v.id === 'cbct') return;
                    v['upload_later'] = this.handleUploadLater(v, false, retrackCaseFile, key);
                    v['will_not_upload'] = this.handleWillNotUpload(v, retrackCaseFile, key);
                } else {
                    key = v.category + stlKey;
                    stlKey = stlKey + 1;
                    let filePath = retrackDataResult.retrackImpressionResult[key];
                    v['data'] = filePath
                        ? /^https?:\/\//.test(filePath)
                            ? filePath
                            : join(ApiServerUrl, filePath)
                        : '';
                    v['dataURL'] = filePath ? v['data'] : null;
                    v['uploaded'] = v['data'] ? true : false;
                    v['upload_later'] = this.handleUploadLater(v, false, retrackCaseImpression, key);
                    v['will_not_upload'] = this.handleWillNotUpload(v, retrackCaseImpression, key);
                }
            });

            intialState['files'] = modifiedFilesData;

            // Explain: initialState will be set in setDefaultValueImpressionTextField
            this.setDefaultValueImpressionTextField(false, retrackCaseImpression, retrackCaseFile, intialState);
            this.props.setTempData(intialState);
        }

        draftFileList = (await axios.get(draftFileListUrl)).data.draft_file_list;
        this.props.handleInitDraftFileList(draftFileList, chosenDraftFile);
        const auth = this.props.auth;
        if (auth.user?.role === ROLE_NAMES.doctor) {
            if (!this.state.threeshapeConnected) {
                try {
                    let { data } = await axios.get(`/threeshape/check_connect`);
                    if (data.success) {
                        this.setState({ threeshapeConnected: true });
                    } else {
                        this.setState({ threeshapeConnected: false });
                    }
                } catch (e) {
                    console.error(e.message);
                    this.setState({ threeshapeConnected: false });
                }
            }
            this.props.fetchScannerPlatform();
        }

        const cbctFile = this.props.files?.find((f) => f.id === 'cbct') 
            || this.props.NewPatientData?.files?.find((f) => f.id === 'cbct');

        if (cbctFile && typeof cbctFile.data === 'string' && /^dbx::/.test(cbctFile.data)) {
            const folderName = cbctFile.data.replace('dbx::', '');
            this.dbx.folder_name = folderName;
            await this.fetchCbctFileCount(folderName);
        }

        this.setState({ LoadingStatus: false });
    }

    // Done: refactor the complex inline syntax to a function
    handleUploadLater(v, refinementDraft, retrackDraft, key) {
        if (v['uploaded']) {
            return false;
        } else if (refinementDraft && refinementDraft[key + '_later'] !== null) {
            return refinementDraft[key + '_later'];
        } else if (retrackDraft && retrackDraft[key + '_later'] !== null) {
            return retrackDraft[key + '_later'];
        } else {
            return false;
        }
    }

    // Done: refactor the complex inline syntax to a function
    handleWillNotUpload(v, refinementDraft, retrackDraft, key) {
        if (refinementDraft && refinementDraft[key + '_later'] === null) {
            return true;
        } else if (retrackDraft && retrackDraft[key + '_later'] === null) {
            return true;
        } else {
            return false;
        }
    }

    handleImpressionWillNotUpload(v, refinementDraft, retrackDraft, key) {
        // refinementDraft[0].case_impression && refinementDraft[0].case_impression['stl_files_later'] === null
        if (refinementDraft && refinementDraft['stl_files_later'] === null) {
            return true;
        } else if (retrackDraft && retrackDraft[key + '_later'] === null) {
            return true;
        } else {
            return false;
        }
    }

    // Done: refactor the complex inline syntax to a function
    handleImpressionTextField(field, refinementImpression, retrackImpression, lastReturnValue = '') {
        if (refinementImpression && refinementImpression[field]) {
            return refinementImpression[field];
        } else if (retrackImpression && retrackImpression[field]) {
            return retrackImpression[field];
        } else {
            return lastReturnValue;
        }
    }

    // Purpose: set default value for impression text field and reduce duplicated code
    setDefaultValueImpressionTextField = (
        refinementImpression,
        retrackCaseImpression,
        retrackCaseFile,
        intialState
    ) => {
        const fields = [
            { key: 'scannerBrand', field: 'scanner_brand' },
            { key: 'doctorId', field: 'doctor_id' },
            { key: 'modernCode', field: 'modern_code' },
            { key: 'waybillNumber', field: 'waybill_number' },
            { key: 'courierCompany', field: 'courier_company' },
            { key: 'impressionType', field: 'type' },
        ];
        const defaultValues = ['', '', '', '', '', 'FILE'];

        fields.forEach(({ key, field }, index) => {
            intialState[key] = this.handleImpressionTextField(
                field,
                refinementImpression,
                retrackCaseImpression,
                defaultValues[index]
            );
        });

        intialState['ray_draft_changed'] = retrackCaseFile.ray_draft_changed
            ? JSON.parse(retrackCaseFile.ray_draft_changed)
            : [];
    };

    setDefaultValueFileAndImpression = (
        v,
        index,
        retrackDataResult,
        refinementDraft,
        handleUploadLater,
        handleWillNotUpload,
        handleImpressionWillNotUpload
    ) => {
        let radioKey = 0,
            stlKey = 0,
            key = '';
        let retrackCaseFile = retrackDataResult.retrackFileResult;
        let retrackCaseImpression = retrackDataResult.retrackImpressionResult;
        let refinementCaseFile = refinementDraft[0].case_file;
        let refinementCaseImpression = refinementDraft[0].case_impression;

        if (v.category === 'photo' || v.category === 'radio') {
            key = v.category === 'radio' ? v.category + radioKey : v.category + index;
            radioKey = v.category === 'radio' ? radioKey + 1 : 0;
            let filePath = refinementCaseFile[key]
                ? refinementCaseFile[key]
                : handleUploadLater && handleWillNotUpload && handleImpressionWillNotUpload && retrackCaseFile[key];

            v['data'] = filePath
                ? /^https?:\/\//.test(filePath) || /^dbx::/.test(filePath)
                    ? filePath
                    : join(ApiServerUrl, filePath)
                : '';
            v['dataURL'] = filePath ? v['data'] : null;
            v['uploaded'] = v['data'] ? true : false;
            if (v.id === 'cbct') return;
            v['upload_later'] = handleUploadLater;
            v['will_not_upload'] = handleWillNotUpload;
        } else {
            key = v.category + stlKey;
            stlKey = stlKey + 1;
            let filePath = refinementCaseImpression[key] ? refinementCaseImpression[key] : retrackCaseImpression[key];
            v['data'] = filePath ? (/^https?:\/\//.test(filePath) ? filePath : join(ApiServerUrl, filePath)) : '';
            v['dataURL'] = filePath ? v['data'] : null;
            v['uploaded'] = v['data'] ? true : false;
            v['upload_later'] = handleUploadLater;
            v['will_not_upload'] =
                handleImpressionWillNotUpload === 'same' ? handleWillNotUpload : handleImpressionWillNotUpload;
        }
    };

    handleSetDefaultRetrackDataToRefinement = () => {
        let newState = { ...this.props.NewPatientData };
        let intialState = {};
        let retrackCaseFile = this.state.retrackFileResult;
        let retrackCaseImpression = this.state.retrackImpressionResult;

        //set Photo Data
        let modifiedFilesData = [...this.props.NewPatientData.files];
        let radioKey = 0,
            stlKey = 0,
            key = '';
        modifiedFilesData.forEach((v, index) => {
            if (v.category === 'photo' || v.category === 'radio') {
                key = v.category === 'radio' ? v.category + radioKey : v.category + index;
                radioKey = v.category === 'radio' ? radioKey + 1 : 0;

                let filePath = retrackCaseFile[key];
                v['data'] = filePath
                    ? /^https?:\/\//.test(filePath) || /^dbx::/.test(filePath)
                        ? filePath
                        : join(ApiServerUrl, filePath)
                    : '';
                v['dataURL'] = filePath ? v['data'] : null;
                v['uploaded'] = v['data'] ? true : false;
                if (v.id === 'cbct') return;
                v['upload_later'] = this.handleUploadLater(v, false, retrackCaseFile, key);
                v['will_not_upload'] = this.handleWillNotUpload(v, retrackCaseFile, key);
            } else {
                key = v.category + stlKey;
                stlKey = stlKey + 1;
                let filePath = retrackCaseImpression[key];
                v['data'] = filePath ? (/^https?:\/\//.test(filePath) ? filePath : join(ApiServerUrl, filePath)) : '';
                v['dataURL'] = filePath ? v['data'] : null;
                v['uploaded'] = v['data'] ? true : false;
                v['upload_later'] = this.handleUploadLater(v, false, retrackCaseImpression, key);
                v['will_not_upload'] = this.handleWillNotUpload(v, retrackCaseImpression, key);
            }
        });

        intialState['files'] = modifiedFilesData;
        this.setDefaultValueImpressionTextField(false, retrackCaseImpression, retrackCaseFile, intialState);
        let allData = { ...newState, ...intialState };
        this.props.setTempData(allData);
    };

    setDefaultValueStepPosition(retrackStepNumberResult) {
        let upperStep = retrackStepNumberResult.aligner_upper;
        let lowerStep = retrackStepNumberResult.aligner_lower;
        if (upperStep === 0) {
            return 'archToTreatLower';
        }

        if (lowerStep === 0) {
            return 'archToTreatUpper';
        }

        return 'both';
    }

    setDefaultValueStepNumber = (retrackStepNumber, initialState = {}) => {
        initialState['archToTreat'] = this.setDefaultValueStepPosition(retrackStepNumber);
        initialState['archToTreatUpperStep'] = retrackStepNumber.aligner_upper;
        initialState['archToTreatLowerStep'] = retrackStepNumber.aligner_lower;
    };

    handleSetDefaultRetrackStepToRefinement = (retrackStepNumber) => {
        let newState = { ...this.props.NewPatientData };
        let initialState = {};

        this.setDefaultValueStepNumber(retrackStepNumber, initialState);

        let allData = { ...newState, ...initialState };
        this.props.setTempData(allData);
    };

    checkStepInput = (modifiedState) => {
        let newState = { ...this.props.NewPatientData };
        let currentStepValid = true;
        const archToTreat = newState['archToTreat'] ? newState['archToTreat'] : undefined;
        if (!archToTreat) {
            return false;
        }
        const caseDetail = modifiedState['case_detail'];
        switch (archToTreat) {
            case 'both':
                if (
                    !caseDetail['refinement_arch_to_treat_upper_step'] ||
                    !caseDetail['refinement_arch_to_treat_lower_step']
                ) {
                    currentStepValid = false;
                }
                break;
            case 'archToTreatUpper':
                if (!caseDetail['refinement_arch_to_treat_upper_step']) {
                    currentStepValid = false;
                }
                break;
            case 'archToTreatLower':
                if (!caseDetail['refinement_arch_to_treat_lower_step']) {
                    currentStepValid = false;
                }
                break;
            default:
                throw new Error('Invalid Arch To Treat value');
        }
        return currentStepValid;
    };

    checkFieldsBeforeSubmit = (option, modifiedState) => {
        const { mandatoryCounter, mandatoryPhotoWithoutValueCounter, uploadPhotoLater } = option;
        let fieldsValid = true;
        if (mandatoryCounter > 0) {
            this.setState({ mandatoryPhotoDataValidation: true });
            return false;
        }
        if (mandatoryPhotoWithoutValueCounter > 0 && !uploadPhotoLater) {
            this.setState({ mandatoryPhotoWithoutData: true });
            return false;
        }
        try {
            const {
                attachments1,
                spacingAndCrowding1,
                openbite1,
                deepBite1,
                midline1,
                posteriorCrossbite1,
                archToTreat,
                auxiliaries1,
                anteriorPosteriorRelationship1,
            } = this.props.NewPatientData;
            const conditions = checkFormFields({
                attachments: attachments1,
                spacingAndCrowding: spacingAndCrowding1,
                openbite: openbite1,
                deepBite: deepBite1,
                midline: midline1,
                posteriorCrossbite: posteriorCrossbite1,
                archToTreat,
                auxiliaries: auxiliaries1,
                anteriorPosteriorRelationship: anteriorPosteriorRelationship1,
            });
            const isHavingError = isConditionsHavingErrors(conditions);
            if (isHavingError) {
                this.setState({
                    currentPatientValidation: true,
                    currentPatientValidationMessage: this.get('@Newpatient.warning.prescription_notes'),
                });
                return false;
            }
            const isStepInputValid = this.checkStepInput(modifiedState);
            if (!isStepInputValid) {
                this.setState({
                    currentPatientValidation: true,
                    currentPatientValidationMessage: this.get('@Newpatient.warning.stepNumber'),
                });
                return false;
            }
        } catch (error) {
            this.setState({ currentPatientValidation: true });
            return false;
        }
        return fieldsValid;
    };

    // Purpose: submit refinement case
    async handleDataSave(save_type, uploadPhotoLater = false) {
        const form = new FormData();

        let newState = { ...this.props.NewPatientData };
        let modifiedKey,
            modifiedState = {},
            case_file = {},
            case_impression = {},
            case_detail = {},
            questionnaire_teeth_array,
            radioCounter = 0,
            stlCounter = 0;
        let questionnaire_teeth = newState['teeth'];
        let files = newState['files'];

        questionnaire_teeth_array = questionnaire_teeth
            .map((value, index) => (value.checked ? index : undefined))
            .filter((v) => v !== undefined);

        files.forEach((value, index) => {
            if (value.category == 'stl_file') {
                const fileName = `$$FILE:stl_file${stlCounter}`;
                case_impression['stl_file' + stlCounter] = getFormToken(form, value.data, fileName);
                case_impression['stl_files_later'] = value.will_not_upload ? null : value.upload_later;
                stlCounter++;
            } else if (!['CN'].includes(process.env.REACT_APP_ENV) && value.id === 'cbct') {
                case_file['radio2'] = { data: value.data, rotate: 0 };
                case_file['radio2_later'] = value.upload_later ? true : value.will_not_upload ? null : false;
            } else if (value.category == 'radio') {
                const fileName = `$$FILE:radio${radioCounter}`;
                case_file['radio' + radioCounter] = {
                    data: getFormToken(form, value.data, fileName),
                    rotate: value.rotate,
                };
                case_file['radio' + radioCounter + '_later'] = value.will_not_upload ? null : value.upload_later;
                radioCounter++;
            } else {
                const fileName = `$$FILE:photo${index}`;
                case_file['photo' + index] = {
                    data: getFormToken(form, value.data, fileName),
                    flipped: value.flipped,
                    rotate: value.rotate,
                };
                case_file['photo' + index + '_later'] = value.will_not_upload ? null : value.upload_later;
            }
        });

        let ModifiedName = {
            /* "extraction": "attr0",
      "expansion": "attr1",
      "interproximal_reduction": "attr2",
      "distalization": "attr3",
      "proclination": "attr4",
      "treatment_simulation": "attr5",
      "over_jet": "attr6",
      "over_bite": "attr7",
      "mid_line": "attr8",
      "cross_bite": "attr9",
      "comment": "attr12",
      "clinical_condition_comment": "clinical_cond_comment", */
            arch_to_treat: 'attr0',
            aligners_margin_placement1: 'attr3',
            special_instructions1: 'attr47',
        };
        Object.keys(newState).forEach(function (key, value) {
            modifiedKey = key
                .replace(/(?:^|\.?)([A-Z])/g, function (x, y) {
                    return '_' + y.toLowerCase();
                })
                .replace(/^_/, '');
            if (['archToTreatLowerStep', 'archToTreatUpperStep'].includes(key)) {
                const prefix = 'refinement_';
                modifiedKey = prefix + modifiedKey;
                case_detail[modifiedKey] = newState[key];
            }

            if (Object.keys(ModifiedName).includes(modifiedKey)) {
                const attrName = ModifiedName[modifiedKey];
                case_detail[attrName] = newState[key];
            }
            if (
                modifiedKey == 'scanner_brand' ||
                modifiedKey == 'doctor_id' ||
                modifiedKey == 'modern_code' ||
                modifiedKey == 'waybill_number' ||
                modifiedKey == 'courier_company'
            ) {
                if (newState[key] && newState[key].length > 0) {
                    case_impression[modifiedKey] = newState[key];
                }
            } else if (modifiedKey === 'not_to_treat1') {
                case_detail['new_excluded_dentition'] = JSON.parse(JSON.stringify(newState[key].sort())).toString();
            } else if (modifiedKey === 'attachments1') {
                case_detail['attr1'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].value).replace(/\"/g, '')
                        : 'placeAttachmentsAsNeeded';
                case_detail['new_excluded_attachments'] = JSON.parse(
                    JSON.stringify(newState[key].doNotPlace.sort())
                ).toString();
                case_detail['new_included_attachments'] = JSON.parse(
                    JSON.stringify(newState[key].place.sort())
                ).toString();
                case_detail['attr2'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].delay.value).replace(/\"/g, '')
                        : 'delayToStage';
                case_detail['attr63'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].delay.stage).replace(/\"/g, '')
                        : '';
            } else if (modifiedKey === 'anterior_posterior_relationship1') {
                case_detail['attr4'] =
                    typeof newState[key] === 'object' ? JSON.stringify(newState[key].r).replace(/\"/g, '') : 'maintain';
                case_detail['attr5'] =
                    typeof newState[key] === 'object' ? JSON.stringify(newState[key].l).replace(/\"/g, '') : 'maintain';
            } else if (modifiedKey === 'spacing_and_crowding1') {
                case_detail['attr6'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].spacing.value).replace(/\"/g, '')
                        : 'closeAllSpaces';
                case_detail['attr64'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].spacing.location).replace(/\"/g, '')
                        : '';
                case_detail['attr7'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveUpper.expand.value).replace(/\"/g, '')
                        : 'asNeeded';
                case_detail['attr48'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveUpper.expand.teeth).replace(/\"/g, '')
                        : '';
                case_detail['attr8'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveUpper.procline.value).replace(/\"/g, '')
                        : 'asNeeded';
                case_detail['attr49'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveUpper.procline.teeth).replace(/\"/g, '')
                        : '';
                case_detail['attr9'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveUpper.IPRAnterior.value).replace(/\"/g, '')
                        : 'asNeeded';
                case_detail['attr50'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveUpper.IPRAnterior.teeth).replace(/\"/g, '')
                        : '';
                case_detail['attr10'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveUpper.IPRPosteriorRight.value).replace(/\"/g, '')
                        : 'asNeeded';
                case_detail['attr51'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveUpper.IPRPosteriorRight.teeth).replace(/\"/g, '')
                        : '';
                case_detail['attr11'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveUpper.IPRPosteriorLeft.value).replace(/\"/g, '')
                        : 'asNeeded';
                case_detail['attr52'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveUpper.IPRPosteriorLeft.teeth).replace(/\"/g, '')
                        : '';
                case_detail['attr12'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveUpper.extraction.value).replace(/\"/g, '')
                        : 'asNeeded';
                case_detail['attr53'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveUpper.extraction.teeth).replace(/\"/g, '')
                        : '';
                case_detail['attr13'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveLower.expand.value).replace(/\"/g, '')
                        : 'asNeeded';
                case_detail['attr54'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveLower.expand.teeth).replace(/\"/g, '')
                        : '';
                case_detail['attr14'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveLower.procline.value).replace(/\"/g, '')
                        : 'asNeeded';
                case_detail['attr55'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveLower.procline.teeth).replace(/\"/g, '')
                        : '';
                case_detail['attr15'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveLower.IPRAnterior.value).replace(/\"/g, '')
                        : 'asNeeded';
                case_detail['attr56'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveLower.IPRAnterior.teeth).replace(/\"/g, '')
                        : '';
                case_detail['attr16'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveLower.IPRPosteriorRight.value).replace(/\"/g, '')
                        : 'asNeeded';
                case_detail['attr57'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveLower.IPRPosteriorRight.teeth).replace(/\"/g, '')
                        : '';
                case_detail['attr17'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveLower.IPRPosteriorLeft.value).replace(/\"/g, '')
                        : 'asNeeded';
                case_detail['attr58'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveLower.IPRPosteriorLeft.teeth).replace(/\"/g, '')
                        : '';
                case_detail['attr18'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveLower.extraction.value).replace(/\"/g, '')
                        : 'asNeeded';
                case_detail['attr59'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].crowding.resolveLower.extraction.teeth).replace(/\"/g, '')
                        : '';
            } else if (modifiedKey === 'over_jet1') {
                case_detail['attr19'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].value).replace(/\"/g, '')
                        : 'maintainInitialOverjet';
                case_detail['attr20'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].subValue).replace(/\"/g, '') === 'null'
                            ? ''
                            : JSON.stringify(newState[key].subValue).replace(/\"/g, '')
                        : '';
            } else if (modifiedKey === 'openbite1') {
                let extrudeIntrudePlace = [];
                let extrudeAnteriorTeeth = [];
                let intrudePosteriorTeeth = [];
                if (newState[key].subValue.extrudeAnteriorTeeth.value === true)
                    extrudeIntrudePlace.push('extrudeAnteriorTeeth');
                if (newState[key].subValue.intrudePosteriorTeeth.value === true)
                    extrudeIntrudePlace.push('intrudePosteriorTeeth');
                if (newState[key].subValue.placeMiniImplantsTAD.value === true)
                    extrudeIntrudePlace.push('placeMiniImplantsTAD');
                if (newState[key].subValue.extrudeAnteriorTeeth.upper === true) extrudeAnteriorTeeth.push('upper');
                if (newState[key].subValue.extrudeAnteriorTeeth.lower === true) extrudeAnteriorTeeth.push('lower');
                if (newState[key].subValue.intrudePosteriorTeeth.upper === true) intrudePosteriorTeeth.push('upper');
                if (newState[key].subValue.intrudePosteriorTeeth.lower === true) intrudePosteriorTeeth.push('lower');
                case_detail['attr21'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].value).replace(/\"/g, '')
                        : 'maintainInitialOpenbite';
                case_detail['attr22'] =
                    typeof newState[key] === 'object' && newState[key].subValue.value !== null
                        ? JSON.stringify(newState[key].subValue.value).replace(/\"/g, '')
                        : '';
                case_detail['attr23'] = JSON.stringify(extrudeIntrudePlace);
                case_detail['attr24'] = JSON.stringify(extrudeAnteriorTeeth);
                case_detail['attr25'] = JSON.stringify(intrudePosteriorTeeth);
                case_detail['attr60'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].subValue.placeMiniImplantsTAD.input).replace(/\"/g, '')
                        : '';
            } else if (modifiedKey === 'deep_bite1') {
                let intrudeExtrudePlace = [];
                let intrudeAnteriorTeeth = [];
                let extrudePosteriorTeeth = [];
                if (newState[key].subValue.intrudeAnteriorTeeth.value === true)
                    intrudeExtrudePlace.push('intrudeAnteriorTeeth');
                if (newState[key].subValue.extrudePosteriorTeeth.value === true)
                    intrudeExtrudePlace.push('extrudePosteriorTeeth');
                if (newState[key].subValue.placeMiniImplantsTAD.value === true)
                    intrudeExtrudePlace.push('placeMiniImplantsTAD');
                if (newState[key].subValue.intrudeAnteriorTeeth.upper === true) intrudeAnteriorTeeth.push('upper');
                if (newState[key].subValue.intrudeAnteriorTeeth.lower === true) intrudeAnteriorTeeth.push('lower');
                if (newState[key].subValue.extrudePosteriorTeeth.upper === true) extrudePosteriorTeeth.push('upper');
                if (newState[key].subValue.extrudePosteriorTeeth.lower === true) extrudePosteriorTeeth.push('lower');
                case_detail['attr26'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].value).replace(/\"/g, '')
                        : 'maintainExistingDeepBite';
                case_detail['attr27'] =
                    typeof newState[key] === 'object' && newState[key].subValue.value !== null
                        ? JSON.stringify(newState[key].subValue.value).replace(/\"/g, '')
                        : '';
                case_detail['attr28'] = JSON.stringify(intrudeExtrudePlace);
                case_detail['attr29'] = JSON.stringify(intrudeAnteriorTeeth);
                case_detail['attr30'] = JSON.stringify(extrudePosteriorTeeth);
                case_detail['attr61'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].subValue.placeMiniImplantsTAD.input).replace(/\"/g, '')
                        : '';
            } else if (modifiedKey === 'midline1') {
                let upperLowerChecked = [];
                if (newState[key].subValue.upper.checked === true) upperLowerChecked.push('upper');
                if (newState[key].subValue.lower.checked === true) upperLowerChecked.push('lower');
                case_detail['attr31'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].value).replace(/\"/g, '')
                        : 'maintainInitialMidline';
                case_detail['attr32'] =
                    typeof newState[key] === 'object' && newState[key].subValue.value !== null
                        ? JSON.stringify(newState[key].subValue.value).replace(/\"/g, '')
                        : '';
                case_detail['attr34'] =
                    typeof newState[key] === 'object' && newState[key].subValue.upper.value !== null
                        ? JSON.stringify(newState[key].subValue.upper.value).replace(/\"/g, '')
                        : '';
                case_detail['attr35'] =
                    typeof newState[key] === 'object' && newState[key].subValue.lower.value !== null
                        ? JSON.stringify(newState[key].subValue.lower.value).replace(/\"/g, '')
                        : '';
                case_detail['attr33'] = JSON.stringify(upperLowerChecked);
            } else if (modifiedKey === 'posterior_crossbite1') {
                let buttonPressedDirectlyOnAlignerSubValue = [];
                let cutoutToBondButtonDirectlyOnTeethSubValue = [];
                if (newState[key].subValue.subValue.buttonPressedDirectlyOnAligner.maxillaryTeeth === true)
                    buttonPressedDirectlyOnAlignerSubValue.push('maxillaryTeeth');
                if (newState[key].subValue.subValue.buttonPressedDirectlyOnAligner.mandibularTeeth === true)
                    buttonPressedDirectlyOnAlignerSubValue.push('mandibularTeeth');
                if (newState[key].subValue.subValue.cutoutToBondButtonDirectlyOnTeeth.maxillaryTeeth === true)
                    cutoutToBondButtonDirectlyOnTeethSubValue.push('maxillaryTeeth');
                if (newState[key].subValue.subValue.cutoutToBondButtonDirectlyOnTeeth.mandibularTeeth === true)
                    cutoutToBondButtonDirectlyOnTeethSubValue.push('mandibularTeeth');
                case_detail['attr36'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].value).replace(/\"/g, '')
                        : 'maintainInitialCrossbite';
                case_detail['attr37'] =
                    typeof newState[key] === 'object' && newState[key].subValue.value !== null
                        ? JSON.stringify(newState[key].subValue.value).replace(/\"/g, '')
                        : 'noPreferenceShowResultsInSimulator';
                case_detail['attr38'] =
                    typeof newState[key] === 'object' && newState[key].subValue.subValue.value !== null
                        ? JSON.stringify(newState[key].subValue.subValue.value).replace(/\"/g, '')
                        : '';
                case_detail['attr39'] = JSON.stringify(buttonPressedDirectlyOnAlignerSubValue);
                case_detail['attr40'] = JSON.stringify(cutoutToBondButtonDirectlyOnTeethSubValue);
                //case_detail["attr46"] = typeof newState[key] === 'object' && newState[key].subValue.subValue.otherMethod !== null ? JSON.stringify(newState[key].subValue.subValue.otherMethod).replace(/\"/g, "") : ""
                case_detail['attr46'] =
                    typeof newState[key] === 'object' &&
                    newState[key].subValue.subValue.otherMethod &&
                    newState[key].subValue.subValue.otherMethod !== null
                        ? JSON.stringify(newState[key].subValue.subValue.otherMethod).replace(/\"/g, '')
                        : '';
            } else if (modifiedKey === 'auxiliaries1') {
                case_detail['attr41'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].classIIElastics).replace(/\"/g, '')
                        : 'No';
                case_detail['attr42'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].classIIIElastics).replace(/\"/g, '')
                        : 'No';
                let auxiliaries1SubValue = [];
                if (!(case_detail['attr41'] === 'No' && case_detail['attr42'] === 'No')) {
                    auxiliaries1SubValue.push(newState[key].subValue.upper.value);
                    auxiliaries1SubValue.push(newState[key].subValue.lower.value);
                }
                case_detail['attr43'] = JSON.stringify(auxiliaries1SubValue);
                case_detail['attr44'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].otherElastics.value).replace(/\"/g, '')
                        : 'No';
                case_detail['attr62'] =
                    typeof newState[key] === 'object'
                        ? JSON.stringify(newState[key].otherElastics.comment).replace(/\"/g, '')
                        : '';
            } else if (modifiedKey === 'trio_dim_force') {
                case_detail['trio_dim_force'] = newState[key];
            }
        });

        case_detail = Object.fromEntries(
            Object.entries(case_detail).map(([key, value]) => {
                if (typeof value === 'number') {
                    const v = !isNaN(value) ? value : null;
                    return [key, v];
                }
                if (String.isBlank(value)) {
                    return [key, null];
                }
                return [key, value];
            })
        );

        if (case_impression.stl_files_later) {
            for (let i = 0; i < 4; i++) case_impression[`stl_file${i}`] = null;
        }

        // case_detail['excluded_dentition'] = questionnaire_teeth_array.join(',')
        // case_detail['clinical_cond'] = newState['clinical_cond']

        case_detail['case_detail_id'] = this.state.case_detail_id;
        case_file['case_file_id'] = this.state.case_file_id;
        case_impression['case_impression_id'] = this.state.case_impression_id;
        case_impression['type'] = newState.impressionType;

        modifiedState['case_detail'] = case_detail;
        modifiedState['case_file'] = case_file;
        modifiedState['case_impression'] = case_impression;

        modifiedState['comment'] = this.state.comments;
        modifiedState['clinical_condition_comment'] = this.state.clinicalConditionComment;
        modifiedState['case_id'] = this.state.caseId;

        if (this.state.refinement_id) {
            modifiedState['refinement_id'] = this.state.refinement_id;
        }

        if (this.props.NewPatientData.chosenDraftFile) {
            modifiedState['chosen_draft_file'] = this.props.NewPatientData.chosenDraftFile;
        }

        if (this.props.NewPatientData.ray_draft_changed) {
            modifiedState['ray_draft_changed'] = this.props.NewPatientData.ray_draft_changed;
        }
        modifiedState['enable_ray_select_choose3d_file'] = this.props.NewPatientData.enableRaySelectChoose3dFile;
        modifiedState['case_rfs_id'] = this.props.NewPatientData.caseRfsId;

        let mandatoryCounter = 0,
            mandatoryPhotoWithoutValueCounter = 0,
            stronglyRecommended = 0;

        files.map((value, index) => {
            // there is no upload later button in cbct, so it need to hard code value.id !="cbct"
            // mandatory photo are first six photo and "front_with_smile"
            if (
                ['photo', 'radio'].includes(value.category) &&
                !value.data &&
                !value.upload_later &&
                !value.will_not_upload &&
                value.id == 'front_with_smile' &&
                value.id != 'cbct'
            ) {
                mandatoryCounter += 1;
            }
            if (
                value.category === 'photo' &&
                !value.data &&
                !value.will_not_upload &&
                index < 6
            ) {
                if (!value.upload_later) {
                    mandatoryCounter += 1;
                } else {
                    mandatoryPhotoWithoutValueCounter += 1;
                }
            }
        });

        files.map((value, index) => {
            if (
                value.category === 'photo' &&
                !value.data &&
                !value.upload_later &&
                !value.will_not_upload &&
                index >= 6
            ) {
                stronglyRecommended += 1;
            }
        });

        modifiedState['refinement_status'] = save_type;

        modifiedState.case_detail = {
            ...modifiedState.case_detail,
            is_refinement: true, // a flag for backend to validate case_detail based on different condition, refer to CaseModel.CaseDetail.getInvalidFields
        };
        if (this.state.defect_resubmit_flag === true) {
            // 1 is represent defect resubmit , 0 or null is refinement
            modifiedState['defect_resubmit_flag'] = 1;
        } else {
            modifiedState['defect_resubmit_flag'] = 0;
        }
        form.append('body', JSON.stringify(modifiedState));

        if (save_type === 'SUBMITTED') {
            const isFieldsValid = this.checkFieldsBeforeSubmit(
                { mandatoryCounter, mandatoryPhotoWithoutValueCounter, uploadPhotoLater },
                modifiedState
            );
            if (!isFieldsValid) return;
        }
        this.handleSaveValidatedData(form);
    }

    async handleSaveValidatedData(form) {
        try {
            this.setState({ loading: true });
            await axios.post(`case/refinement/${this.state.caseId}`, form, {
                onUploadProgress: this.progressBarRef.current?.onProgressChange,
            });
            await this.props.showSnackbar('Success', 'success', true);
            // this.props.history.push(`/patients/${this.state.patientId}/${this.state.caseId}/View`)
            this.props.history.push(`/patients/${this.state.caseId}`);
        } catch (e) {
            console.error(e.response);
            if (e.response?.data?.invalid) {
                const translation = {
                    modern_code: this.get('impressions.byCourierLabel'),
                    scanner_brand: this.get('impressions.byScannerBrandLabel'),
                    doctor_id: this.get('impressions.byScannerUserNameLabel'),
                };
                const invalidFields = e.response.data.invalid.map((v) => translation[v] ?? v).join(',');
                this.props.showSnackbar(`Please enter ${invalidFields}`, 'error');
            } else {
                this.props.showSnackbar(e.response?.data?.message ?? e.message ?? e, 'error');
            }
        } finally {
            this.setState({ loading: false });
        }
    }

    handleRoatate(image_id, degree) {
        this.props.handleRoatateImage(image_id, degree);
    }

    checkIfImageExists(image_id) {
        let image_data = this.props.files.filter((imageObj) => {
            return imageObj.id == image_id;
        });
        return image_data[0].uploaded;
    }

    getImage(image_id) {
        let image_data = this.props.files.filter((imageObj) => {
            return imageObj.id == image_id;
        });
        return image_data[0];
    }

    handleUpload(image_id, file) {
        NewPatientHandleUpload(image_id, file, this.props.handleDataFileUpload);
        this.forceUpdate();
    }
    setMandatoryPhotoWithoutData(val) {
        this.setState({ mandatoryPhotoWithoutData: val });
    }

    setMandatoryPhotoDataValidation(val) {
        this.setState({ mandatoryPhotoDataValidation: val });
    }

    setMandatoryPhotoValidationDarft(val) {
        this.setState({ mandatoryPhotoValidationDarft: val });
    }

    dbx = {
        folder_name: '',
        url: '',
        pageOpen: false,
    };

    createDropboxLink = async () => {
        if (!this.dbx.pageOpen) {
            if (!this.dbx.url.length || !this.dbx.folder_name.length) {
                var result = await axios.get('dropbox/getLink');
                this.dbx.folder_name = result.data.folder_name;
                this.dbx.url = result.data.request_url;
                this.handleUpload('cbct', `dbx::${this.dbx.folder_name}`);
            }
            this.dbx.pageOpen = true;
            var dbx_page = window.open(this.dbx.url, '_blank');

            var timer = setInterval(async () => {
                if (dbx_page.closed) {
                    this.dbx.pageOpen = false;
                    clearInterval(timer);
                }
                await this.fetchCbctFileCount(this.dbx.folder_name);
            }, 5000);
        }
    };

    handleDbxPopup = async (open) => {
        if (open) {
            this.setState({ dbxPopup: true });
        } else {
            this.setState({ dbxPopup: false });
            await this.createDropboxLink();
        }
    };

    render() {
        const { LoadingStatus } = this.state;
        return (
            <Fragment>
                <Animated animationIn="fadeIn" isVisible={true} style={{ backgroundColor: 'rgb(242, 242, 242)' }}>
                    <PercentageProgressRing ref={this.progressBarRef} open={this.state.loading} />
                    <Grid container style={{ padding: 16, background: '#fff' }}>
                        <Grid
                            item
                            xs={12}
                            style={{
                                padding: 32,
                            }}
                        >
                            <Banner />
                        </Grid>

                        {this.state.isUnderRetrackFlow && (
                            <Grid item xs={12}>
                                <div style={{ color: 'red' }}>
                                    This refinement involves Using ReTrack uploaded files
                                </div>
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <div
                                style={{
                                    margin: '8px 0px',
                                }}
                            >
                                <Link
                                    to="/"
                                    style={{
                                        color: 'black',
                                    }}
                                >
                                    Case Management
                                </Link>
                                {` > Patient: ${this.props.match.params.id} > ${this.state.defect_resubmit_flag ? 'Defect Resubmit' : 'Refinement'}`}
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                            {/* <Questionnaire /> */}
                            {this.state.isUnderRetrackFlow && (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => {
                                        this.handleSetDefaultRetrackStepToRefinement(
                                            this.state.retrackStepNumberResult
                                        );
                                    }}
                                >
                                    Reset Retrack Step
                                </Button>
                            )}
                            {!this.state.LoadingStatus && <PrescriptionNotes formType={FORM_TYPE.REFINEMENT} />}
                            <ConfirmDialog
                                title="Warning"
                                open={this.state.mandatoryPhotoWithoutData}
                                dialogConfirmation="OK"
                                setOpen={(val) => this.setMandatoryPhotoWithoutData(val)}
                                onConfirm={() => this.handleDataSave('SUBMITTED', true)}
                            >
                                For mandatory photos, you have indicated that you will upload it later.Please note that
                                our technicians will await all mandatory data before beginning to treatment plan of the
                                case
                            </ConfirmDialog>

                            <ConfirmDialog
                                title="Warning"
                                open={this.state.mandatoryPhotoDataValidation}
                                dialogConfirmation="OK"
                                setOpen={(val) => this.setMandatoryPhotoDataValidation(val)}
                            >
                                Mandatory photos are not uploaded, please save draft and proceed{' '}
                                {this.state.defect_resubmit_flag ? 'defect resubmit' : 'refinement'} submission
                                afterwards
                            </ConfirmDialog>

                            <ConfirmDialog
                                title="Warning"
                                open={this.state.mandatoryPhotoValidationDarft}
                                dialogConfirmation="OK"
                                setOpen={(val) => this.setMandatoryPhotoValidationDarft(val)}
                            >
                                Please upload all the images or check upload later option for Photo,Radiograph and
                                Impression
                            </ConfirmDialog>

                            <ConfirmDialog
                                title={'Warning'}
                                dialogConfirmation={'OK'}
                                open={this.state.currentPatientValidation}
                                setOpen={() => this.setState({ currentPatientValidation: false })}
                                onConfirm={() => {
                                    const element = document.getElementById('Q1');
                                    if (element) {
                                        element.scrollIntoView({ behavior: 'smooth' });
                                    }
                                }}
                            >
                                {this.state.currentPatientValidationMessage}
                            </ConfirmDialog>

                            <WarningDialog
                                title="Warning Message"
                                open={this.state.submitConfirmation}
                                setOpen={() => this.setState({ submitConfirmation: false })}
                                onConfirm={() => this.handleDataSave('SUBMITTED')}
                            >
                                <div>
                                    Are you sure to submit this
                                    {this.state.defect_resubmit_flag ? ' defect resubmit' : ' refinement'}
                                </div>
                                <br></br>
                                <br></br>

                                {
                                    // Only display when
                                    // there was request of “Send only cycle 1” in SEVERE distortion before
                                    // there was request of “Send cycles 1 to 6” in either Moderate or SEVERE distortion
                                    this.state.defect_resubmit_flag === true &&
                                    (this.state.defectCurrentStatus.currentDefectFlow.dr_response ===
                                        'Send Cycles 1 to 6' ||
                                        (this.state.defectCurrentStatus.currentDefectFlow.defect_type === 'Minor' &&
                                            this.state.defectCurrentStatus.currentDefectFlow.dr_response ===
                                                'Send Cycle 1 only')) ? (
                                        <div>
                                            Reminder: An additional charge will be incurred if the aligners from{' '}
                                            {this.state.defectCurrentStatus.currentDefectFlow.dr_response ===
                                            'Send Cycle 1 only'
                                                ? 'cycle 1'
                                                : 'cycles 1-6'}{' '}
                                            do not fit correctly and new impression is needed for case resubmit.
                                        </div>
                                    ) : (
                                        <></>
                                    )
                                }
                            </WarningDialog>

                            <NewConfirmDialog
                                title="Confirmation"
                                open={this.state.draftConfirmation}
                                dialogConfirmation="Confirm"
                                onClose={() => this.setState({ draftConfirmation: false })}
                                onConfirm={() => this.handleDataSave('DRAFT')}
                            >
                                Are you sure to save as draft?
                            </NewConfirmDialog>

                            {LoadingStatus ? (
                                <Loader />
                            ) : (
                                <>
                                    {this.state.isUnderRetrackFlow && (
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => this.handleSetDefaultRetrackDataToRefinement()}
                                        >
                                            Reset all below fields to Retrack Data
                                        </Button>
                                    )}
                                    <Photos
                                        tabMode="photos"
                                        parent="refinement"
                                        enableRaySelectChoose3dFile={
                                            this.props.NewPatientData.enableRaySelectChoose3dFile
                                        }
                                        caseRfsId={this.props.NewPatientData.caseRfsId}
                                        rayFiles={this.state.rayFiles}
                                        handleEnableChoose3dFileChange={(value) =>
                                            this.handleEnableChoose3dFileChange(value)
                                        }
                                        handleChoose3dFile={(value) => this.handleChoose3dFile(value)}
                                    />
                                </>
                            )}
                            <h3 className={style2.heading}>{this.get('radiographs.uploadRadiograph')}</h3>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={4}>
                                    <NewPatientPhoto
                                        imageId="front_with_smile"
                                        imageUploaded={this.checkIfImageExists('front_with_smile')}
                                        imageData={this.getImage('front_with_smile')}
                                        label="Upload this photo later"
                                        labelSecondary="Will not submit"
                                        imageName="bg_xray1.png"
                                        uploadLater={true}
                                        no_warning={true}
                                        will_not_upload={true}
                                        will_not_upload_label={this.get(':uploadType.willNotUploadXray')}
                                        imageLabel={`${this.get('radiographs.orthopantomogram')} - ${this.get(':uploadType.mandatory')}`}
                                        labelUnderImage=" "
                                        handleRoatate={(degree) => {
                                            this.handleRoatate('front_with_smile', degree);
                                        }}
                                        handleChange={(file) => {
                                            this.handleUpload('front_with_smile', file);
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <NewPatientPhoto
                                        imageId="side_with_smile"
                                        imageUploaded={this.checkIfImageExists('side_with_smile')}
                                        imageData={this.getImage('side_with_smile')}
                                        label="I will upload this X-ray later"
                                        imageName="bg_xray2.png"
                                        will_not_upload={true}
                                        uploadLater={true}
                                        no_warning={true}
                                        will_not_upload_label={this.get(':uploadType.willNotUploadXray')}
                                        imageLabel={`${this.get('radiographs.lateralCephalogram')} - ${this.get(':uploadType.stronglyRecommended')}`}
                                        labelUnderImage=" "
                                        handleRoatate={(degree) => {
                                            this.handleRoatate('side_with_smile', degree);
                                        }}
                                        handleChange={(file) => {
                                            this.handleUpload('side_with_smile', file);
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    {this.props.files.filter((imageObj) => {
                                        return imageObj.id == 'cbct';
                                    }).length > 0 &&
                                    typeof this.props.files.filter((imageObj) => {
                                        return imageObj.id == 'cbct';
                                    })[0].data === 'string' &&
                                    this.props.files
                                        .filter((imageObj) => {
                                            return imageObj.id == 'cbct';
                                        })[0]
                                        .data?.includes('s3:') ? (
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '100%',
                                            }}
                                        >
                                            CBCT files are inside the RFS file
                                        </div>
                                    ) : ['CN'].includes(process.env.REACT_APP_ENV) ? (
                                        <NewPatientPhoto
                                            imageId="cbct"
                                            imageUploaded={this.checkIfImageExists('cbct')}
                                            imageData={this.getImage('cbct')}
                                            label={this.get(':uploadType.uploadXrayLater')}
                                            imageName="cbct.png"
                                            no_warning={true}
                                            imageLabel={`${this.get('radiographs.cbct_dicom')} - ${this.get(':uploadType.optional')}`}
                                            labelUnderImage="FOV 16(W)X10(H)"
                                            handleRoatate={(degree) => {
                                                this.handleRoatate('cbct', degree);
                                            }}
                                            handleChange={(file) => {
                                                this.handleUpload('cbct', file);
                                            }}
                                        />
                                    ) : (
                                        <>
                                            <div style={{ width: '100%' }}>
                                                <div className={style2.card}>
                                                    <div
                                                        className={style2.uploadBtnWrapper}
                                                        onClick={async () => await this.handleDbxPopup(true)}
                                                    >
                                                        <button className={style2.btn}>+</button>
                                                        <span className={style2.ImageLabelText}>
                                                            {this.get('radiographs.cbct_dicom')} -{' '}
                                                            {this.get(':uploadType.optional')}
                                                        </span>
                                                    </div>
                                                    <div className={style2.cardImage}>
                                                        <img src={getWebAbsPath('/img/cbct.png')} />
                                                    </div>
                                                    <div className={style2.uploadBtnWrapper}>
                                                        <span className={style2.ImageLabelText}></span>
                                                    </div>
                                                </div>
                                                {LoadingStatus ? (<LoadingSpinner/>) : (
                                                <div className={style2.uploadFooter}>
                                                    <p
                                                        style={{
                                                            fontSize: 18,
                                                            marginBlockEnd: 0,
                                                            marginLeft: 15,
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {this.state.dbxFileCount > 0
                                                            ? `${this.state.dbxFileCount} files uploaded`
                                                            : ''}
                                                    </p>
                                                </div>)}
                                            </div>

                                            <AlertDialog
                                                title="Upload Instruction"
                                                dialogOpen={this.state.dbxPopup}
                                                handleDialogClose={async () => await this.handleDbxPopup(false)}
                                                content={
                                                    'Do not close the upload page until finish. Close the page after finish.'
                                                }
                                            />
                                        </>
                                    )}
                                </Grid>
                            </Grid>
                            <Photos
                                tabMode="impression"
                                threeshapeConnected={this.state.threeshapeConnected}
                                handleThreeshapeConnected={(value) => this.setState({ threeshapeConnected: value })}
                                uploadLater={'patientInfo'}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                onClick={() => this.setState({ submitConfirmation: true })}
                                style={{
                                    background: 'rgba(89,54,135,1)',
                                    color: 'white',
                                    padding: '4px 24px',
                                    marginLeft: '12px',
                                    float: 'right',
                                }}
                                disabled={this.state.LoadingStatus}
                            >
                                {this.get('@NewPatient.navBtns.submit')}
                            </Button>
                            <Button
                                onClick={() => this.setState({ draftConfirmation: true })}
                                style={{
                                    background: 'rgba(89,54,135,1)',
                                    color: 'white',
                                    padding: '4px 24px',
                                    float: 'right',
                                }}
                                disabled={this.state.LoadingStatus}
                            >
                                {this.get('@NewPatient.navBtns.saveDraft')}
                            </Button>
                        </Grid>
                    </Grid>
                </Animated>
            </Fragment>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        NewPatientData: store.newPatientReducer,
        files: store.newPatientReducer.files,
        config: store.config.config,
        lang: store.lang,
        isLoading: store.loading.isLoading,
        auth: store.auth,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleDataFileUpload: (id, value) => dispatch({ type: actionTypes.NEW_PATIENT_FILES, id: id, value: value }),
        handleInitDraftFileList: (draftFileList, chosenDraftFile) =>
            dispatch({ type: actionTypes.NEW_PATIENT_INIT_DRAFT_FILE, draftFileList, chosenDraftFile }),
        setTempData: (newPatientData) => dispatch(saveAction.tempSave(newPatientData)),
        handleRoatateImage: (id, value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_FILE_ROTATE, id: id, value: value }),
        showSnackbar: (msg, variant, queue = false) => dispatch(easySnackbar(msg, variant, queue)),
        handleEnableChoose3dFile: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_ENABLE_RAY_CHOOSE_3dFILE, value: value }),
        handleChoose3dFile: (value) => dispatch({ type: actionTypes.NEW_PATIENT_3dFILE_CHOOSED, value: value }),
        handlePrescriptionErrorScrollId: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_PRES_ERROR_SCROLL_ID, value }),
        fetchScannerPlatform: () => dispatch(fetchConnectPlatformData()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLang(Refinement, 'NewPatient')));
